module.exports = __webpack_public_path__ + "img/4_55.b69d5322.png";